"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        key: 'labelPosition',
        ignore: true
    },
    {
        key: 'placeholder',
        ignore: true
    },
    {
        key: 'description',
        ignore: true
    },
    {
        key: 'hideLabel',
        ignore: false
    },
    {
        key: 'autofocus',
        ignore: true
    },
    {
        key: 'tooltip',
        ignore: true
    },
    {
        key: 'tabindex',
        ignore: true
    },
    {
        key: 'disabled',
        ignore: true
    },
    {
        type: 'select',
        input: true,
        weight: 20,
        tooltip: 'Select type you\'d like to use.',
        key: 'showType',
        defaultValue: 'bar',
        label: 'Chart type',
        dataSrc: 'values',
        data: {
            values: [
                { label: 'Bar chart', value: 'bar' },
                { label: 'Bubble chart', value: 'bubble' },
                { label: 'Doughnut chart', value: 'doughnut' },
                { label: 'Pie chart', value: 'pie' },
                { label: 'Line chart', value: 'line' },
                { label: 'Radar chart', value: 'radar' },
                { label: 'Polar area chart', value: 'polarArea' },
            ],
        },
    },
    {
        type: 'textarea',
        key: 'custom',
        label: 'Button Custom Logic',
        tooltip: 'The custom logic to evaluate when the button is clicked.',
        rows: 5,
        editor: 'ace',
        input: true,
        weight: 103,
        placeholder: "data['mykey'] = data['anotherKey'];",
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'custom'] },
        },
    },
    {
        type: 'textarea',
        input: true,
        key: 'chartOptions',
        label: 'Chart Options',
        editor: 'ace',
        as: 'javascript',
        rows: 3,
        weight: 18,
        tooltip: 'insert chart options',
    },
];
